import { useEffect, useState } from "react";
import { db } from "../database";

const useCount = (status: string, update?: string) => {
	const [count, setCount] = useState(0);
	const [refreshCount, setRefreshCount] = useState(0);

	const event = db.on("changes");

	useEffect(() => {
		const sub = () => {
			setRefreshCount(refreshCount + 1);
		};
		db.on("changes", sub);
		//@ts-ignore
		return () => db.on("changes").unsubscribe(sub);
	}, [refreshCount]);

	useEffect(() => {
		const getCount = async () => {
			if (status === "all") {
				const sitesCount = await db.userSites
					.where("status")
					.notEqual("deleted")
					.count();
				setCount(sitesCount);
			} else {
				const sitesCount = await db.userSites
					.where("status")
					.equals(status)
					.count();
				setCount(sitesCount);
			}
		};
		getCount();
	}, [status, update, refreshCount]);
	return count;
};

export default useCount;
